// R11P GEOLOGICAL P0.5-P9C — URL safety for backend-provided links/media.
//
// A URL that arrives from the API (an export link, a dataset media preview) is
// untrusted presentation data. Before it is placed in an href/src we must reject
// executable or data-smuggling schemes. Only http(s), protocol-relative, and
// same-origin relative URLs are allowed; javascript:, data:, vbscript:, blob:
// and anything else resolve to undefined so the element renders nothing rather
// than a dangerous target.

const SAFE_ABSOLUTE = /^https?:\/\//i;

/** True only for a URL that is safe to use as an href/src. */
export function isSafeHttpUrl(raw: unknown): raw is string {
  if (typeof raw !== 'string') return false;
  const url = raw.trim();
  if (!url) return false;
  // Relative or absolute same-site paths (no scheme) are safe.
  if (url.startsWith('/') && !url.startsWith('//')) return true;
  // Protocol-relative //host/… inherits the page's https scheme — allowed.
  if (url.startsWith('//')) return true;
  // Absolute URLs must be http(s). This rejects javascript:, data:, vbscript:,
  // blob:, file: and any other scheme.
  return SAFE_ABSOLUTE.test(url);
}

/** Returns the URL when safe, otherwise undefined (so href/src renders nothing). */
export function safeUrl(raw: unknown): string | undefined {
  return isSafeHttpUrl(raw) ? raw.trim() : undefined;
}
